exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reader-footer{border-top:none}.reader-content{border-radius:16px}.modal-title{color:#605ca8;font-size:16px;font-weight:400}.modal-body{padding:30px}", ""]);

// exports
